/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { GapDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class GapApiClient extends BaseCRUDApiClient<GapDto> {
  baseUrl = this.config.apiEndpoint + '/gap';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  calcolaGap() {
    this._pagedCache.clear();
    return this.http.post<GapDto[]>(`${this.baseUrl}/calcola-gap`, {});
  }

  confirmWarning(id: number) {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/confirm-warnig/${id}`);
  }

  cancellazioneGapPerimetro() {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/cancella-gap`);
  }
}
